import { Accordion, Button } from '@skupreme/shared/ui';
import { AccordionBodyContainer, BoldText } from './styles';

export function Customer({ customer, addressValidationClick }) {
  const customerInfo = customer?.name
    ? customer?.name
    : customer?.email
      ? customer?.e_mail
      : customer?.phone
        ? customer?.phone
        : '';
  return (
    <Accordion title="Customer" defaultExpanded headingLevel={4}>
      <AccordionBodyContainer>
        <div className="sk:flex sk:justify-end">
          <Button
            variant="ghost"
            size="sm"
            onPress={() => addressValidationClick()}
          >
            Update Address
          </Button>
        </div>
        <div className="sk:grid sk:grid-cols-2 sk:gap-3">
          <div className="sk:min-w-0">
            <div>Sold To</div>
            <div className="sk:truncate" title={customerInfo}>
              <BoldText>{customerInfo}</BoldText>
            </div>
          </div>
          <div className="sk:min-w-0">
            <div>Ship To:</div>
            <div className="sk:truncate" title={customerInfo}>
              <BoldText>{customerInfo}</BoldText>
            </div>
            <div>
              {customer?.address_line_one
                ? `${customer?.address_line_one}, `
                : ''}
              {customer?.address_line_two
                ? `${customer?.address_line_two}, `
                : ''}
              {customer?.city ? `${customer?.city}, ` : ''}
              {customer?.state ? `${customer?.state}, ` : ''}
              {customer?.zip ? `${customer?.zip}, ` : ''}
              {customer?.country ? `${customer?.country}, ` : ''}
            </div>
            <div>{customer?.phone}</div>
          </div>
        </div>
      </AccordionBodyContainer>
    </Accordion>
  );
}
